import BaseComponent from "./base-component";

export function BaseLayoutFactory({ children }: { children: React.ReactNode }) {

    return (
        <BaseComponent>
            {children}
        </BaseComponent>
    );
}